export default __webpack_public_path__ + "static/media/m-btn-check-defualt-16.941a218b.svg";